import * as React from "react";

import { IBreadcrumbProps } from "@blueprintjs/core";

interface IBreadcumbContext {
  breadcrumbs: IBreadcrumbProps[];
  setBaseBreadcrumb: (breadCrumb: IBreadcrumbProps[]) => void;
  setDetailsBreadcrumb: (breadCrum: IBreadcrumbProps[]) => void;
}

export const BreadcrumbContext = React.createContext<IBreadcumbContext>(null);

export const BreadcrumbProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [baseBreadcrumb, setBaseBreadcrumb] = React.useState<IBreadcrumbProps[]>([]);
  const [detailsBreadcrumb, setDetailsBreadcrumb] = React.useState<IBreadcrumbProps[]>([]);

  const breadcrumbs = React.useMemo(
    () => [...baseBreadcrumb, ...detailsBreadcrumb],
    [baseBreadcrumb, detailsBreadcrumb]
  );

  const baseUrl = React.useMemo(
    () =>
      window.location.href
        ?.split("/")
        ?.find((d) => d.includes("."))
        ?.split(".")[0] ?? "C4D",
    []
  );

  React.useEffect(() => {
    document.title = breadcrumbs && breadcrumbs[0] ? `C4D > ${breadcrumbs[0].text.toString()}` : baseUrl;
  }, [breadcrumbs]);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBaseBreadcrumb, setDetailsBreadcrumb }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => React.useContext(BreadcrumbContext);
